(function() {

  const check = document.querySelector('.archive-agenda');

  if( check ) {

    // ArchiveControler + config

    const news_controler = new ArchiveControler();
      news_controler.register_archive_container( document.getElementById('ArchiveAgenda') );
      
      news_controler.register_filter_select( document.getElementById('Filter_1') );
      news_controler.register_search_input( document.getElementById('Search') );

      news_controler.register_self_loading_classname('agenda__loading');
      news_controler.register_more_button_classname('button__more');

      /*
      news_controler.on('change', function( controller ) {
        var timeout = 50, stagger = 150; // animatie via class-remove (in ms)
        controller.archive_container.querySelectorAll('.new').forEach(element => {
          setTimeout( () => { element.classList.remove('new'); }, timeout);
          timeout += stagger;
        });
      });
      */
  }

})();